/**
 * NFeCancelModal Component
 * 
 * Modal para cancelamento de NF-e com validação de justificativa.
 */

import { useEffect, useState } from 'react'
import { AlertTriangle } from 'lucide-react'
import Modal from '../Modal/Modal'
import './NFeCancelModal.css'

function NFeCancelModal({ isOpen, onClose, onConfirm, nfe, loading = false, initialJustificativa = '' }) {
  const [justificativa, setJustificativa] = useState('')
  const [error, setError] = useState('')

  useEffect(() => {
    if (!isOpen) return
    setJustificativa(initialJustificativa || '')
    setError('')
  }, [isOpen, initialJustificativa])

  const handleConfirm = () => {
    // Validar justificativa
    if (!justificativa || justificativa.trim().length < 15) {
      setError('Justificativa deve ter no mínimo 15 caracteres')
      return
    }

    setError('')
    onConfirm(justificativa.trim())
  }

  const handleClose = () => {
    setJustificativa('')
    setError('')
    onClose()
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Cancelar NF-e"
      size="medium"
    >
      <div className="nfe-cancel-modal">
        <div className="cancel-warning">
          <AlertTriangle size={24} />
          <div>
            <h3>Atenção!</h3>
            <p>Esta ação não pode ser desfeita. A NF-e será cancelada na SEFAZ.</p>
            {nfe && (
              <p className="nfe-info">
                <strong>NF-e #{nfe.number}</strong> - Chave: {nfe.access_key?.substring(0, 20)}...
              </p>
            )}
          </div>
        </div>

        <div className="form-field">
          <label htmlFor="justificativa">
            Justificativa do Cancelamento <span className="required">*</span>
            <span className="char-count">
              ({justificativa.length}/15 mínimo)
            </span>
          </label>
          <textarea
            id="justificativa"
            value={justificativa}
            onChange={(e) => {
              setJustificativa(e.target.value)
              setError('')
            }}
            placeholder="Digite a justificativa do cancelamento (mínimo 15 caracteres)..."
            rows={4}
            className={error ? 'error' : ''}
            disabled={loading}
          />
          {error && <span className="error-message">{error}</span>}
          <p className="help-text">
            A justificativa é obrigatória e deve ter no mínimo 15 caracteres conforme legislação.
          </p>
        </div>

        <div className="modal-footer">
          <button
            className="btn-secondary"
            onClick={handleClose}
            disabled={loading}
          >
            Cancelar
          </button>
          <button
            className="btn-danger"
            onClick={handleConfirm}
            disabled={loading || justificativa.trim().length < 15}
          >
            {loading ? 'Cancelando...' : 'Confirmar Cancelamento'}
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default NFeCancelModal
